import axiosInstance from "../axiosInstance";

export const categorySalesService = {
  /**
   * Fetch aggregated category sales for the planner.
   * Returns a hierarchical structure: root categories with children.
   * @param {string|null} client - client id
   * @param {number|null} year   - plan year (defaults to current year on backend)
   */
  fetchPlanner: async (client, year, dimension) => {
    try {
      let api = `/category-sales`;
      const params = [];
      if (client) params.push(`client=${client}`);
      if (year) params.push(`year=${year}`);
      if (dimension && dimension !== "category")
        params.push(`dimension=${dimension}`);
      if (params.length) api += `?${params.join("&")}`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
